import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

const List = styled.ul`
  position: relative;
  & li {
    position: relative;
    text-align: center;
    font-size: 20px;
    letter-spacing: 0.2px;
    width: fit-content;
    margin: 0 auto 16px;
    transition: opacity 0.2s ease;
    &::after {
      content: "";
      position: absolute;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #474dc4;
      top: 50%;
      left: 0;
      transform: translate(-16px, -50%);
    }
    &:nth-last-child(2) {
      margin-bottom: 0;
    }
    &:last-child {
      position: absolute;
      top: 0;
      opacity: 0;
      font-family: "Made Light", sans-serif;
      line-height: 32px;
      &::after {
        display: none;
      }
    }
  }
`

const Card = styled.div`
  width: 270px;
  height: 325px;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 12px 18px 0 rgba(0, 0, 0, 0.05), 0 4px 6px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  transition: 0.2s ease;
  cursor: pointer;
  border: solid 2px #fff;
  &.card-pc {
    display: none;
    @media (min-width: 768px) {
      display: flex;
    }
  }
  & div {
    padding: 30px 20px;
    & img {
      width: 48px;
      height: 48px;
      margin: 0 auto 20px;
      display: block;
    }
    & h3 {
      font-size: 24px;
      letter-spacing: 0.5px;
      padding-bottom: 20px;
      margin-bottom: 20px;
      position: relative;
      text-align: center;
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 70px;
        height: 2px;
        border-radius: 2px;
        border: solid 1px #c39779;
      }
    }
    & p {
      font-size: 20px;
      letter-spacing: 0.2px;
      text-align: center;
    }
  }
  &:hover {
    border: solid 2px #c39779;
    box-shadow: 0 24px 36px 0 rgba(0, 0, 0, 0.1), 0 8px 12px 0 rgba(195, 151, 121, 0.3);
    transform: translateY(-10px);
    ${List} li {
      opacity: 0;
      &:last-child {
        opacity: 1;
      }
    }
  }
`

const CardOffer = ({ icon, title, description, className, list }) => {
  return (
    <Card className={className}>
      <div>
        <img src={icon} alt={title} />
        <h3>{title}</h3>
        <List>
          {list.map(item => (
            <li key={item}>{item}</li>
          ))}
          <li>{description}</li>
        </List>
      </div>
    </Card>
  )
}

export default CardOffer

CardOffer.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  list: PropTypes.arrayOf(PropTypes.string).isRequired,
  className: PropTypes.string,
}

CardOffer.defaultProps = {
  className: null,
}
